import { render } from "./ActionPlaceOrder.vue?vue&type=template&id=8f87fe84&scoped=true"
import script from "./ActionPlaceOrder.vue?vue&type=script&lang=js"
export * from "./ActionPlaceOrder.vue?vue&type=script&lang=js"

import "./ActionPlaceOrder.vue?vue&type=style&index=0&id=8f87fe84&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f87fe84"]])

export default __exports__